
URL = globalThis.URL
import __vite__wasmUrl from "/home/martin/code/progenitor/crates/wasm/pkg/progenitor_wasm_bg.wasm?url"
import __vite__initWasm from "/__vite-plugin-wasm-helper"
import * as __vite__wasmImport_0 from "./progenitor_wasm_bg.js";
const __vite__wasmModule = await __vite__initWasm({ "./progenitor_wasm_bg.js": { "__wbg_new_405e22f390576ce2": __vite__wasmImport_0["__wbg_new_405e22f390576ce2"],
"__wbindgen_number_new": __vite__wasmImport_0["__wbindgen_number_new"],
"__wbg_set_3f1d0b984ed272ed": __vite__wasmImport_0["__wbg_set_3f1d0b984ed272ed"],
"__wbg_new_78feb108b6472713": __vite__wasmImport_0["__wbg_new_78feb108b6472713"],
"__wbg_push_737cfc8c1432c2c6": __vite__wasmImport_0["__wbg_push_737cfc8c1432c2c6"],
"__wbindgen_memory": __vite__wasmImport_0["__wbindgen_memory"],
"__wbg_buffer_609cc3eee51ed158": __vite__wasmImport_0["__wbg_buffer_609cc3eee51ed158"],
"__wbg_newwithbyteoffsetandlength_d97e637ebe145a9a": __vite__wasmImport_0["__wbg_newwithbyteoffsetandlength_d97e637ebe145a9a"],
"__wbg_new_a12002a7f91c75be": __vite__wasmImport_0["__wbg_new_a12002a7f91c75be"],
"__wbindgen_string_new": __vite__wasmImport_0["__wbindgen_string_new"],
"__wbg_new_8a6f238a6ece86ea": __vite__wasmImport_0["__wbg_new_8a6f238a6ece86ea"],
"__wbg_stack_0ed75d68575b0f3c": __vite__wasmImport_0["__wbg_stack_0ed75d68575b0f3c"],
"__wbg_error_7534b8e9a36f1ab4": __vite__wasmImport_0["__wbg_error_7534b8e9a36f1ab4"],
"__wbg_getRandomValues_21a0191e74d0e1d3": __vite__wasmImport_0["__wbg_getRandomValues_21a0191e74d0e1d3"],
"__wbindgen_throw": __vite__wasmImport_0["__wbindgen_throw"],
"__wbindgen_init_externref_table": __vite__wasmImport_0["__wbindgen_init_externref_table"] } }, __vite__wasmUrl);
export const memory = __vite__wasmModule.memory;
export const get_size = __vite__wasmModule.get_size;
export const __wbg_simulation_free = __vite__wasmModule.__wbg_simulation_free;
export const simulation_cell_info = __vite__wasmModule.simulation_cell_info;
export const simulation_cell_text = __vite__wasmModule.simulation_cell_text;
export const simulation_steps = __vite__wasmModule.simulation_steps;
export const simulation_data = __vite__wasmModule.simulation_data;
export const simulation_export_snapshot = __vite__wasmModule.simulation_export_snapshot;
export const simulation_import_snapshot = __vite__wasmModule.simulation_import_snapshot;
export const simulation_viewport_hint = __vite__wasmModule.simulation_viewport_hint;
export const __wbg_viewport_free = __vite__wasmModule.__wbg_viewport_free;
export const __wbg_get_viewport_col = __vite__wasmModule.__wbg_get_viewport_col;
export const __wbg_set_viewport_col = __vite__wasmModule.__wbg_set_viewport_col;
export const __wbg_get_viewport_row = __vite__wasmModule.__wbg_get_viewport_row;
export const __wbg_set_viewport_row = __vite__wasmModule.__wbg_set_viewport_row;
export const __wbg_get_viewport_width = __vite__wasmModule.__wbg_get_viewport_width;
export const __wbg_set_viewport_width = __vite__wasmModule.__wbg_set_viewport_width;
export const __wbg_get_viewport_height = __vite__wasmModule.__wbg_get_viewport_height;
export const __wbg_set_viewport_height = __vite__wasmModule.__wbg_set_viewport_height;
export const demo_simple = __vite__wasmModule.demo_simple;
export const demo_progenitor = __vite__wasmModule.demo_progenitor;
export const __wbg_snapshots_free = __vite__wasmModule.__wbg_snapshots_free;
export const snapshots_new = __vite__wasmModule.snapshots_new;
export const snapshots_getall = __vite__wasmModule.snapshots_getall;
export const demo_falling_sand = __vite__wasmModule.demo_falling_sand;
export const demo_turing = __vite__wasmModule.demo_turing;
export const demo_tumblers = __vite__wasmModule.demo_tumblers;
export const demo_builders_random = __vite__wasmModule.demo_builders_random;
export const demo_builders_optimized = __vite__wasmModule.demo_builders_optimized;
export const demo_sunburn = __vite__wasmModule.demo_sunburn;
export const demo_pairs = __vite__wasmModule.demo_pairs;
export const demo_growth = __vite__wasmModule.demo_growth;
export const demo_growth_default_config = __vite__wasmModule.demo_growth_default_config;
export const demo_growth_with_config = __vite__wasmModule.demo_growth_with_config;
export const demo_rainfall = __vite__wasmModule.demo_rainfall;
export const measure_rainfall = __vite__wasmModule.measure_rainfall;
export const set_panic_hook = __vite__wasmModule.set_panic_hook;
export const is_debug_build = __vite__wasmModule.is_debug_build;
export const __wbindgen_free = __vite__wasmModule.__wbindgen_free;
export const __wbindgen_exn_store = __vite__wasmModule.__wbindgen_exn_store;
export const __externref_table_alloc = __vite__wasmModule.__externref_table_alloc;
export const __wbindgen_export_3 = __vite__wasmModule.__wbindgen_export_3;
export const __wbindgen_malloc = __vite__wasmModule.__wbindgen_malloc;
export const __wbindgen_realloc = __vite__wasmModule.__wbindgen_realloc;
export const __externref_drop_slice = __vite__wasmModule.__externref_drop_slice;
export const __externref_table_dealloc = __vite__wasmModule.__externref_table_dealloc;
export const __wbindgen_start = __vite__wasmModule.__wbindgen_start;
